<script lang="ts">
    import {mySession} from './services';
    import Layout from './Layout.svelte';
    import CurrentConversation from './CurrentConversation.svelte';
</script>

<Layout showFooter={false}>
    <CurrentConversation session={$mySession} />
</Layout>